import { Info } from '@dreamstack/icons'
import Tippy from '@tippyjs/react'
import type { FunctionComponent } from 'react'
import { useEffect, useRef, useState } from 'react'
import 'tippy.js/dist/tippy.css'
import tw, { styled } from 'twin.macro'
import './LtvIconArrow.css'

const StyledInfoIcon = styled(Info)<{
  $isActive?: boolean
}>(({ $isActive }) => [
  tw`h-px-32 w-px-32 cursor-pointer select-none my-px-8`,
  $isActive
    ? tw`text-accentroGray-full ease-linear duration-200`
    : tw`text-accentroGray-400`,
])

const StyledTippyPopover = styled(Tippy)<{}>(({}) => [
  tw`bg-accentroGray-full rounded-none p-px-12 text-accentroWhite-full text-px-13 leading-px-18 md:(min-width[550px] text-px-16 leading-px-24 p-px-32) ml:(min-width[600px])`,
])

export const LtvInfoIcon: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const referenceRef = useRef<HTMLDivElement | null>(null)
  const [openState, setOpenState] = useState(false)

  const handleClickOutside = (event: any) => {
    if (referenceRef.current && !referenceRef.current.contains(event.target)) {
      event.stopPropagation()
    }
  }
  const onHover = (action: 'onMouseEnter' | 'onMouseLeave') => {
    if (action === 'onMouseEnter') setOpenState(true)
    if (action === 'onMouseLeave') setOpenState(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown_', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown_', handleClickOutside)
    }
  })

  return (
    <StyledTippyPopover
      popperOptions={{ modifiers: [{ name: 'flip', enabled: false }] }}
      interactive={true}
      content="Purchase contracts in Germany must be signed in the presence of a notary, who also records the property sale in the land registry. The overall cost of this service is usually around 1.5% of the purchasing price. This will involve an approximately 1% invoice paid directly to the notary office after signing contracts; and approximately 0.5% spread over three separate invoices during the land registry process – removing the old name and entering you as the registered owner."
    >
      <div
        ref={referenceRef}
        onMouseEnter={() => onHover('onMouseEnter')}
        onMouseLeave={() => onHover('onMouseLeave')}
      >
        <StyledInfoIcon
          // ref={referenceRef} TODO: ref was used twice - check if its ok to remove this one and not the one in the parent div
          $isActive={openState}
        ></StyledInfoIcon>
      </div>
    </StyledTippyPopover>
  )
}
